import { IonCard, IonCardContent } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { printNumber, radToDeg } from "../../utils/helpers";
import InfoImg from "../../components/info-image";

import "./styles.css";


const getApertureImage = (aperture: number) => {
	if (aperture < 20) {
		return "/assets/aperture_10.jpeg";
	} else if (aperture >= 20 && aperture < 30) {
		return "/assets/aperture_20.jpeg";
	} else if (aperture >= 30 && aperture < 40) {
		return "/assets/aperture_30.jpeg";
	} else if (aperture >= 40 && aperture < 50) {
		return "/assets/aperture_40.jpeg";
	} else if (aperture >= 50 && aperture < 60) {
		return "/assets/aperture_50.jpeg";
	} else if (aperture >= 60 && aperture < 70) {
		return "/assets/aperture_60.jpeg";
	} else if (aperture >= 70 && aperture < 80) {
		return "/assets/aperture_70.jpeg";
	} else if (aperture >= 80 && aperture < 90) {
		return "/assets/aperture_80.jpeg";
	} else {
		return "/assets/aperture_90.jpeg";
	}
};

const TrawlSystemResults = ({ results }) => {
	const { t } = useTranslation();
	return (
		<IonCard style={{ backgroundColor: results?.__cond?.result || "unset" }}>
			<IonCardContent>
				<div className="ion-text-center">
					<h2 className="calcResultTitle">{t("general.results")}</h2>
					<InfoImg
						imgSrc={getApertureImage(results.distanceBtWindTips)}
					></InfoImg>
					<p>
						<strong>
							{t("system.trawlSystems.results.distanceBtWindTips")}: {results.distanceBtWindTips} %
						</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.doorOpening")}:{" "}
						<strong>{printNumber(results.doorOpening)} m</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.netOpening")}:{" "}
						<strong>{printNumber(results.netOpening)} m</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.strikeAngle")}:{" "}
						<strong>{printNumber(radToDeg(results.strikeAngle))} º</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.gatesSweepArea")}:{" "}
						<strong>{printNumber(results.gatesSweepArea)} m²</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.filteredWaterVolume")}:{" "}
						<strong>{printNumber(results.filteredWaterVolume)} m³/s</strong>
					</p>
				</div>
			</IonCardContent>
		</IonCard>
	);
};

export const TrawlPairSystemResults = ({ results }) => {
	const { t } = useTranslation();
	return (
		<IonCard style={{ backgroundColor: results?.__cond?.result || "unset" }}>
			<IonCardContent>
				<div className="ion-text-center">
					<h2 className="calcResultTitle">{t("general.results")}</h2>
					<InfoImg
						imgSrc={getApertureImage(results.distanceBtWindTips)}
					></InfoImg>
					<p>
						<strong>
							{t("system.trawlSystems.results.distanceBtWindTips")}: {results.distanceBtWindTips} %
						</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.shipOpening")}:{" "}
						<strong>{printNumber(results.doorOpening)} m</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.netOpening")}:{" "}
						<strong>{printNumber(results.netOpening)} m</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.strikeAngle")}:{" "}
						<strong>{printNumber(radToDeg(results.strikeAngle))} º</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.shipsSweepArea")}:{" "}
						<strong>{printNumber(results.gatesSweepArea)} m²</strong>
					</p>
					<p>
						{t("system.trawlSystems.results.filteredWaterVolume")}:{" "}
						<strong>{printNumber(results.filteredWaterVolume)} m³/s</strong>
					</p>
				</div>
			</IonCardContent>
		</IonCard>
	);
};

export default TrawlSystemResults;
